const THREE = require('three')
import raf from 'src/components/game/raf'
import {load, registerSize, loadingManager} from 'src/components/game/loader'
import _ from 'lodash'
import {TweenMax, TimelineMax, Cubic} from 'gsap'
import * as colors from '../../colors'
import * as STAGES from '../../stages'
import {config as gameConfig} from '../../config'

// *****************************************************************
//
// COLORS
//
// *****************************************************************
let inactive = 0xAAAAAA
let inactiveColor = new THREE.Color(inactive)
let activeColor = colors.red.clone()


// *****************************************************************
//
// WRAPPER
//
// *****************************************************************
export let mesh = new  THREE.Object3D()
export default mesh
mesh.name = 'dashboard-chargemeter'


// *****************************************************************
//
// TEXTURES
//
// *****************************************************************
export let bars = [
  {
    url: require('assets/chargemeter/0.png'),
    size: 1116
  },
  {
    url: require('assets/chargemeter/1.png'),
    size: 1215
  },
  {
    url: require('assets/chargemeter/2.png'),
    size: 1375
  },
  {
    url: require('assets/chargemeter/3.png'),
    size: 1390
  },
  {
    url: require('assets/chargemeter/4.png'),
    size: 1192
  }
]
for (let key in bars) {
  let bar = bars[key]
  bar.active = false
  let url = bar.url
  registerSize(url, bar.size)
  load(url, new THREE.TextureLoader(loadingManager), (results)=> {
    bar.map = results[0]
    checkAllLoaded()
  })
}

export let loaded = false
const checkAllLoaded = function () {
  for (let key in bars) {
    if (!bars[key].map) return
  }

  loaded = true
  init()
}


// *****************************************************************
//
// INIT
//
// *****************************************************************
const init = function () {
  for (let key in bars) {
    let bar = bars[key]
    let material = new THREE.MeshBasicMaterial({
      map: bar.map,
      transparent: true,
      alphaTest: 0.1,
      color: inactive
    })
    let geometry = new THREE.PlaneBufferGeometry(50, 50)
    let _m = new THREE.Mesh(geometry, material)
    _m.name = `chargemeter-bar${key}`
    mesh.add(_m)

    bar.material = material
    bar.material.opacity = 0
    bar.mesh = _m
  }
}


// *****************************************************************
//
// Updates
//
// *****************************************************************
export let showBar = function(i) {
  let bar = bars[i]
  if (bar.active) return
  if (bar.tween) bar.tween.kill()
  bar.active = true
  bar.tween = TweenMax.to(bar.material.color, 0.1, {
    r: activeColor.r,
    g: activeColor.g,
    b: activeColor.b,
    repeat: 4,
    yoyo: true
  })
}

export let hideBar = function(i, time = 0.3) {
  let bar = bars[i]
  if (!bar.active) return
  if (bar.tween) bar.tween.kill()
  bar.active = false
  bar.tween = TweenMax.to(bar.material.color, time, {
    r: inactiveColor.r,
    g: inactiveColor.g,
    b: inactiveColor.b
  })
}

const update = _.throttle(()=> {

  if (!window.game) return
  if (!loaded) return

  let charge = window.game.state.stage2.charge

  for (let idx = 0; idx < bars.length; idx++) {

    if (window.game.state.stage < STAGES.STAGE2_SLOW) {
      hideBar(idx, 0)
      continue
    }

    if (charge > (idx / (bars.length - 1))) {
      showBar(idx)
    } else {
      // hideBar(idx)
    }
  }
}, gameConfig.uiUpdateInterval)
// raf.on('tick', update)
setInterval(update, gameConfig.uiUpdateInterval)



export let start = (seconds) => {
  let tl = new TimelineMax()
  for (let key in bars) {
    let bar = bars[key]
    tl.to(bar.material, (seconds / bars.length) * key / 2, {opacity: 1, ease: Cubic.easeInOut})
  }
}

export let reset = (seconds) => {
  for (let key in bars) {
    let bar = bars[key]
    bar.material.opacity = 0
  }
}








// WEBPACK FOOTER //
// ./src/components/game/ui/dashboard/chargemeter.js